import consola from 'consola'
import { BaseResource as Resource } from '../defaults/resource'
import cache from './cache'
import columnReducer from './column-reducer'

export default class ApiClient {
  constructor (_axios, context, branch_id, col_reducer = columnReducer) {
    this.request = context.req
    this.branch_id = branch_id
    this.columnReducer = col_reducer

    this.setupCaching()
    this.setupAxios(_axios)
  }

  filter (resources) {
    return resources.filter((r) => {
      if (r.name.startsWith('_')) {
        return false
      }

      return Resource.isValidated(r)
    })
  }

  setupAxios (axios) {
    this.axios = axios.create()
  }

  async getResources () {
    if (this.useCache && this.cache.isFresh()) {
      consola.debug('cache is still fresh, reading from it...')

      return {
        data: this.cache.read()
      }
    }

    consola.debug('requesting fresh resources from API...')

    try {
      const response = await this.axios.get(`/resources`, this.requestConfig())
      if (this.useCache) {
        const filtered = this.filter(response.data)
        response.data = this.columnReducer(filtered)
        this.cache.set(response)
      }

      return response
    } catch (e) {
      if (this.useCache && e.response.status === 304) {
        consola.info('received 304, reading from cache...')
        return {
          data: this.cache.read()
        }
      }
      consola.error(e)
    }
  }

  requestConfig = () => {
    const params = {
      branch_id: this.branch_id
    }

    if (!this.useCache || !this.cache.etag) {
      return {
        params
      }
    }

    return {
      params,
      headers: {
        'Cache-Control': 'public, max-age=120',
        'If-None-Match': this.cache.etag
      }
    }
  }

  setupCaching () {
    this.cache = {}
    if (process.env.DISABLE_API_CACHE) {
      this.useCache = false
      return
    }

    const isEventStream = this.request.headers.accept && this.request.headers.accept.toLowerCase().includes('stream')
    const isGetRequest = (this.request.method === 'GET')

    this.useCache = !isEventStream && isGetRequest && Number(this.branch_id) === 1

    if (this.useCache) {
      this.cache = cache
    }

    return this.useCache
  }
}
